import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { ContentBaseComponent } from '@xanadu/core';
import { Register } from '@xanadu/core';
import { InputConstant } from '@xanadu/input';
import { Content } from '@xanadu/model';

@Component({
    selector: 'app-batch-panel',
    templateUrl: './batch-panel.component.html',
    styleUrls: ['./batch-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('batch-panel')
export class BatchPanelComponent extends ContentBaseComponent {
    tabBatch = { caption: 'Batch', active: true, hidden: false };
    tabPublish = { caption: 'Publish', active: false, hidden: false };

    constructor() {
        super();

        effect(() => {
            const result = this.batchSignal.done();
            if (result) {
                this.noticeSignal.info(`Batch updated ${result.contents?.length} items.`);
                this.formGroup()?.markAsPristine();
            }
        });

        effect(() => {
            const content = this.batchSignal.content();
            if (!content) {
                this.formGroup.set(undefined);
            }
        });
    }

    protected override setup(content: Content): void {
        super.setup(content);

        this.tabs = [
            this.tabBatch, this.tabPublish
        ];
        this.tabSelected = this.tabBatch;
    }

    onSubmit() {
        const batch = this.batchSignal.content();
        const { publish, ...rest } = this.formGroup()?.value;

        if (batch) {
            const content = batch.content;
            content.publish = publish;
            content.data = rest;
            delete content.original;
            Object.keys(content.data).forEach(key => {
                if (key.startsWith(InputConstant.ignorePrefix)) {
                    delete content.data[key];
                }
            });

            this.batchSignal.save.set(content);
        }
    }
}
